require('./bootstrap');

import PageTransition from './page-transitions';
window.PageTransition = PageTransition;

import Swiper, { Navigation, Autoplay, Pagination, EffectFade } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

window.Swiper = Swiper;

// gsap.registerPlugin(ScrollTrigger)
